import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import pt from './locales/pt.json';
import tr from './locales/tr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import hr from './locales/hr.json';
import nl from './locales/nl.json';
import ru from './locales/ru.json';
import sr from './locales/sr.json';
import srCyrl from './locales/sr-Cyrl.json';
import zh from './locales/zh.json';

export const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'hr', label: 'Hrvatski', dir: 'ltr' },
  { code: 'es', label: 'Español', dir: 'ltr' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'pt', label: 'Português', dir: 'ltr' },
  { code: 'tr', label: 'Türkçe', dir: 'ltr' },
  { code: 'de', label: 'Deutsch', dir: 'ltr' },
  { code: 'it', label: 'Italiano', dir: 'ltr' },
  { code: 'ja', label: '日本語', dir: 'ltr' },
  { code: 'nl', label: 'Nederlands', dir: 'ltr' },
  { code: 'ru', label: 'Русский', dir: 'ltr' },
  { code: 'sr', label: 'Srpski', dir: 'ltr' },
  { code: 'sr-Cyrl', label: 'Српски', dir: 'ltr' },
  { code: 'zh', label: '中文', dir: 'ltr' },
] as const;

export type LangCode = typeof LANGUAGES[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hr: { translation: hr },
      es: { translation: es },
      fr: { translation: fr },
      ar: { translation: ar },
      pt: { translation: pt },
      tr: { translation: tr },
      de: { translation: de },
      it: { translation: it },
      ja: { translation: ja },
      nl: { translation: nl },
      ru: { translation: ru },
      sr: { translation: sr },
      'sr-Cyrl': { translation: srCyrl },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// The stored language is applied during init, before this listener exists, so
// the document's direction and language are set once here as well.
function applyDocumentLanguage(lng: string) {
  const lang = LANGUAGES.find((l) => l.code === lng);
  document.documentElement.dir = lang?.dir ?? 'ltr';
  document.documentElement.lang = lng;
}
i18n.on('languageChanged', applyDocumentLanguage);
applyDocumentLanguage(i18n.language);

export default i18n;
